import React, {  useEffect, useState} from 'react';
import { popUp1Caching } from '../components/general/pop-up1';
import { popUp2Caching } from '../components/general/pop-up2';
import { popUp4Caching } from '../components/general/pop-up4';
import { textSizeCaching } from '../components/general/text-size';
import { initialWindowCaching } from '../components/main-menu/windows/initial-window';
import { mainMenuWindowCaching } from '../components/main-menu/windows/main-menu/main-menu-window';
import { referenceMaterialsWindowCaching } from '../components/main-menu/windows/main-menu/reference-materials-window';
import { resumeGameWindowCaching } from '../components/main-menu/windows/main-menu/resume-game-window';
import { settingsWindowCaching } from '../components/main-menu/windows/main-menu/settings-window';
import { startScenariosWindowCaching } from '../components/main-menu/windows/main-menu/start-scenarios-window';
import { accessibilityWindowCaching } from '../components/main-menu/windows/settings/accessibility-window';
import { preLoadAssetsWindowCaching } from '../components/main-menu/windows/settings/pre-load-assets-window';
import { topLeftControlsUICaching } from '../components/ui/hud/top-left-controls-ui';
import { reliabilityGaugeUICaching } from '../components/ui/reliability-gauge-ui';
import { replayContentUICaching } from '../components/ui/replay-content-ui';
import { skipContentUICaching } from '../components/ui/skip-content-ui';
import VideoEnvironment from '../cvp-webgames-core/Components/Environments/React/VideoEnvironment';
import CoreControlledMainUI from '../cvp-webgames-core/Components/ui/react/core-controlled/core-controlled-main-ui';
import CoreDemoScenario from '../cvp-webgames-core/Components/ui/react/core-controlled/demo-scenario/core-demo-scenario';
import GameManager from '../cvp-webgames-core/GameManager';
import { useWindowSize } from '../cvp-webgames-core/hooks/useWindowSize';
import Tools from '../cvp-webgames-core/Misc/Tools';
import { PreCacheManager } from '../cvp-webgames-core/pre-caching/pre-cache-manager';
import ReactSoundManager from '../cvp-webgames-core/Sound/ReactSoundManager';
import JsxUIManager from '../cvp-webgames-core/UI/JsxUiManager';
import { VideoSegmentManager } from '../cvp-webgames-core/VideoSegment/VideoSegmentManager';
import { constants } from '../misc/constants';
import { globals } from '../misc/globals';
import { generalAudioCaching, getSaveData, PageType, setFocus, setFocusToElement, setVisibilityState } from '../misc/tools';
import { scenario1PivBadgeAudioCaching, scenario1PivBadgeVideoSegments } from '../scenarios/scenario1-piv-badge/scenario1-piv-badge';
import { scenario10FallWithInjuryAudioCaching, scenario10FallWithInjuryVideoSegments } from '../scenarios/scenario10-fall-with-injury/scenario10-fall-with-injury';
import { scenario2NonAffiliatedStudentsAudioCaching, scenario2NonAffiliatedStudentsVideoSegments } from '../scenarios/scenario2-non-affiliated-students/scenario2-non-affiliated-students';
import { scenario3IncorrectPtAdmittedAudioCaching, scenario3IncorrectPtAdmittedVideoSegments } from '../scenarios/scenario3-incorrect-pt-admitted/scenario3-incorrect-pt-admitted';
import { scenario4WcWorkStoppageAudioCaching, scenario4WcWorkStoppageVideoSegments } from '../scenarios/scenario4-wc-work-stoppage/scenario4-wc-work-stoppage';
import { scenario5BufferInMriAudioCaching, scenario5BufferInMriVideoSegments } from '../scenarios/scenario5-buffer-in-mri/scenario5-buffer-in-mri';
import { scenario6SurgeryWardAudioCaching, scenario6SurgeryWardVideoSegments } from '../scenarios/scenario6-surgery-ward/Scenario6-surgery-ward';
import { scenario7TransfusionAudioCaching, scenario7TransfusionVideoSegments } from '../scenarios/scenario7-transfusion/Scenario7-transfusion';
import { scenario8RmeTempHumAudioCaching, scenario8RmeTempHumVideoSegments } from '../scenarios/scenario8-rme-temp-hum/scenario8-rme-temp-hum';
import { scenario9GtubeMedAdmAudioCaching, scenario9GtubeMedAdmVideoSegments } from '../scenarios/scenario9-gtube-med-adm/scenario9-gtube-med-adm';
import GamePage from './Game';
import MainMenuPage, { mainMenuVideoCaching } from './MainMenu';
import { mixedMediaUICaching, mixedMediaUIImgCaching } from '../components/ui/mixed-media';

localStorage.setItem('isInAccessibilityScreen-jcdst', '0');
localStorage.removeItem('accessibility_menu_open-jcdst');
var saveData = getSaveData();
(window as any)['core-motion-disabled'] = !saveData.isMotionEnabled;
(window as any)['muted-audio'] = !saveData.isAudioEnabled;
setVisibilityState(saveData.isVisibleFocusEnabled);

const MainPage = () => {
	const [windowToUse, setWindowToUse] = useState(PageType.Nothing.toString());
	const [skipText, setSkipText] = useState('');
	let isInitializing: boolean = false;

	const windowSize: any = useWindowSize();

	const scale = Math.min(windowSize.width / 1920, windowSize.height / 1080);
	globals.worldScale = scale;

	const preCacheManager = new PreCacheManager();
	const videoSegmentManager = new VideoSegmentManager();

	const registerItemsToPreCache = () => {
		preCacheManager.registerItem(popUp1Caching);
		preCacheManager.registerItem(popUp2Caching);
		preCacheManager.registerItem(popUp4Caching);
		preCacheManager.registerItem(textSizeCaching);
		preCacheManager.registerItem(initialWindowCaching);
		preCacheManager.registerItem(mainMenuWindowCaching);
		preCacheManager.registerItem(referenceMaterialsWindowCaching);
		preCacheManager.registerItem(resumeGameWindowCaching);
		preCacheManager.registerItem(settingsWindowCaching);
		preCacheManager.registerItem(startScenariosWindowCaching);
		preCacheManager.registerItem(accessibilityWindowCaching);
		preCacheManager.registerItem(preLoadAssetsWindowCaching);
		preCacheManager.registerItem(topLeftControlsUICaching);
		preCacheManager.registerItem(reliabilityGaugeUICaching);
		preCacheManager.registerItem(replayContentUICaching);
		preCacheManager.registerItem(resumeGameWindowCaching);
		preCacheManager.registerItem(skipContentUICaching);
		preCacheManager.registerItem(mixedMediaUIImgCaching);

		preCacheManager.registerItem(generalAudioCaching);

		preCacheManager.registerItem(scenario1PivBadgeAudioCaching);
		preCacheManager.registerItem(scenario2NonAffiliatedStudentsAudioCaching);
		preCacheManager.registerItem(scenario3IncorrectPtAdmittedAudioCaching);
		preCacheManager.registerItem(scenario4WcWorkStoppageAudioCaching);
		preCacheManager.registerItem(scenario5BufferInMriAudioCaching);
		preCacheManager.registerItem(scenario6SurgeryWardAudioCaching);
		preCacheManager.registerItem(scenario7TransfusionAudioCaching);
		preCacheManager.registerItem(scenario8RmeTempHumAudioCaching);
		preCacheManager.registerItem(scenario9GtubeMedAdmAudioCaching);
		preCacheManager.registerItem(scenario10FallWithInjuryAudioCaching);
	}

	const registerVideoSegments = () => {
		videoSegmentManager.registerItem(scenario1PivBadgeVideoSegments);
		videoSegmentManager.registerItem(scenario2NonAffiliatedStudentsVideoSegments);
		videoSegmentManager.registerItem(scenario3IncorrectPtAdmittedVideoSegments);
		videoSegmentManager.registerItem(scenario4WcWorkStoppageVideoSegments);
		videoSegmentManager.registerItem(scenario5BufferInMriVideoSegments);
		videoSegmentManager.registerItem(scenario6SurgeryWardVideoSegments);
		videoSegmentManager.registerItem(scenario7TransfusionVideoSegments);
		videoSegmentManager.registerItem(scenario8RmeTempHumVideoSegments);
		videoSegmentManager.registerItem(scenario9GtubeMedAdmVideoSegments);
		videoSegmentManager.registerItem(scenario10FallWithInjuryVideoSegments);
		videoSegmentManager.registerItem(mixedMediaUICaching);
		videoSegmentManager.registerItem(mainMenuVideoCaching);
	}

	useEffect(() => {
		if(!isInitializing) {
			let url = new URL(window.location.href);
			let search_params = url.searchParams;
			let w: any = search_params.get('w');
			if(w && w !== PageType.Nothing) {
				setWindowToUse(w);
			} else {
				setWindowToUse(PageType.MainMenu);
			}
			setTimeout(() => {
				(window as any)['uiContainerChanged']();
			}, 0);
			isInitializing = true;

			registerItemsToPreCache();
			registerVideoSegments();
		}
	})


	
	return (
		<div style={{
			position: 'relative',
			top: '0',
			left: '0',
		}}>
			<div style={{
				position: "fixed",
				width: "1920px",
				height: "1080px",
				transform: `scale(${scale}) translate(-50%, -50%)`,
				transformOrigin: "0px 0px",
				top: "50%",
				left: "50%",
				overflow: 'hidden'
			}} id="game-root-page-obj">
				<div id="main-bg-img" style={{
					position: 'absolute',
					width: '100%',
					height: '100%',
					background: `#000000 url(${process.env.PUBLIC_URL}/assets/images/main-menu/main-menu-bg.png) no-repeat center center`
					}}>

				</div>
				<div style={{
					position: 'absolute',
					top: '0',
					left: '0',
					width: '100%',
					height: '100%',
					overflow: 'hidden',
				}}>
					{windowToUse === PageType.MainMenu || windowToUse === PageType.Scenarios ? <MainMenuPage updateWindow={Tools.updateWindow} isInScenarios={windowToUse === PageType.Scenarios} preCacheManager={preCacheManager}></MainMenuPage> : (null)}
					{windowToUse !== PageType.MainMenu && windowToUse !== PageType.Scenarios ? <GamePage updateWindow={Tools.updateWindow} scenarioId={windowToUse.toString()}></GamePage> : (null)}
				</div>
				<CoreControlledMainUI debugMode={constants.debugMode} videoSegmentManager={videoSegmentManager}></CoreControlledMainUI>
			</div>
		</div>
		
	);
};

export default MainPage;
